// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Layout from './components/Shared/Layout';
import WelcomeScreen from './components/Shared/WelcomeScreen';

// Ppulbatu routes
import FrameSelectionPpulbatu from './components/Ppulbatu/1ChooseMember';
import BoothPpulbatu from './components/Ppulbatu/2Photobooth';
import ConfirmPpulbatu from './components/Ppulbatu/3ConfirmPhotos';
import SelectPpulbatu from './components/Ppulbatu/4SelectPhotos';
import ResultPpulbatu from './components/Ppulbatu/5ShowResult';

// TMRWMember routes
import FrameSelectionTMRWMember from './components/TMRWMember/1ChooseMember';
import BoothTMRWMember from './components/TMRWMember/2Photobooth';
import SelectTMRWMember from './components/TMRWMember/4SelectPhotos';
import ResultTMRWMember from './components/TMRWMember/5ShowResult';
import ConfirmTMRWMember from './components/TMRWMember/3ConfirmPhotos';

// LLMember routes
import FrameSelectionLLMember from './components/LLMember/1ChooseMember';
import BoothLLMember from './components/LLMember/2Photobooth';
import SelectLLMember from './components/LLMember/4SelectPhotos';
import ResultLLMember from './components/LLMember/5ShowResult';
import ConfirmLLMember from './components/LLMember/3ConfirmPhotos';

// LLOriginalFrame routes
import BoothLLOriginal from './components/LLOriginal/BoothLLOriginal';
import SelectLLOriginal from './components/LLOriginal/SelectLLOriginal';
import ResultLLOriginal from './components/LLOriginal/ResultLLOriginal';

// IceCream routes (temporary preview page)
import WelcomeIceCream from './components/IceCream/0Welcome';
import FrameSelectionIceCream from './components/IceCream/1ChooseFrame';
import BoothIceCream from './components/IceCream/2Photobooth';
import ConfirmIceCream from './components/IceCream/3ConfirmPhotos';
import SelectIceCream from './components/IceCream/4SelectPhotos';
import ResultIceCream from './components/IceCream/5ShowResult';

import Privacy from './components/Shared/Privacy';
import Footer from './components/Shared/Footer';
import { Analytics } from "@vercel/analytics/react"

const iceCreamRoutes = (
  <>
    <Route path="/icecream" element={<WelcomeIceCream />} />
    <Route path="/icecream/frame-selection" element={<FrameSelectionIceCream />} />
    <Route path="/icecream/photobooth" element={<BoothIceCream />} />
    <Route path="/icecream/confirm" element={<ConfirmIceCream />} />
    <Route path="/icecream/select" element={<SelectIceCream />} />
    <Route path="/icecream/result" element={<ResultIceCream />} />
  </>
);

const DEFAULT_FAVICON = '/img/heart-icon.png';
const ICECREAM_FAVICON = '/img/IceCream/logo.png';

function AppContent() {
  const location = useLocation();
  const isIceCream = location.pathname.startsWith('/icecream');

  useEffect(() => {
    const link = document.querySelector("link[rel='icon']");
    if (link) {
      link.setAttribute('href', isIceCream ? ICECREAM_FAVICON : DEFAULT_FAVICON);
    }
  }, [isIceCream]);

  // IceCream routes render full-bleed with no shared Navbar/Footer/page padding
  // so its background image fills the whole viewport.
  if (isIceCream) {
    return <Routes>{iceCreamRoutes}</Routes>;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<WelcomeScreen />} />
        {/* TMRWMember routes */}
        <Route path="/frame-selection/TMRWMember" element={<FrameSelectionTMRWMember />} />
        <Route path="/photobooth/TMRWMember" element={<BoothTMRWMember />} />
        <Route path="/confirm/TMRWMember" element={<ConfirmTMRWMember />} />
        <Route path="/select/TMRWMember" element={<SelectTMRWMember />} />
        <Route path="/result/TMRWMember" element={<ResultTMRWMember />} />

        {/* LLMember routes */}
        <Route path="/frame-selection/LLMember" element={<FrameSelectionLLMember />} />
        <Route path="/photobooth/LLMember" element={<BoothLLMember />} />
        <Route path="/confirm/member" element={<ConfirmLLMember />} />
        <Route path="/select/member" element={<SelectLLMember />} />
        <Route path="/result/member" element={<ResultLLMember />} />

        {/* LLOriginalFrame routes */}
        <Route path="/photobooth/LLOriginalFrame" element={<BoothLLOriginal />} />
        <Route path="/select/original" element={<SelectLLOriginal />} />
        <Route path="/result/original" element={<ResultLLOriginal />} />

        {/* Ppulbatu routes */}
        <Route path="/frame-selection/Ppulbatu" element={<FrameSelectionPpulbatu />} />
        <Route path="/photobooth/Ppulbatu" element={<BoothPpulbatu />} />
        <Route path="/confirm/Ppulbatu" element={<ConfirmPpulbatu />} />
        <Route path="/select/Ppulbatu" element={<SelectPpulbatu />} />
        <Route path="/result/Ppulbatu" element={<ResultPpulbatu />} />

        <Route path="/privacy" element={<Privacy />} />
      </Routes>
      <Footer />
    </Layout>
  );
}

function App() {
  return (
    <>
      <Analytics />
      <Router>
        <AppContent />
      </Router>
    </>
  );
}

export default App;
// No changes needed; all paths are correct.
